import { VFC } from 'react'
import { Routes, Route, Link } from 'react-router-dom'

import { PrivateRoutes } from 'infrastructure/shared/components'
import WorkflowRoutes from 'workflow/Routes'
import WorkflowmodelRoutes from 'workflowmodel/Routes'
import InteractionRoutes from 'interaction/Routes'
import MasterdataRoutes from 'masterdata/Routes'
import TaskRoutes from 'task/Routes'
import { isEmbedded } from 'shared/utils/iframe'

const ApplicationRouter: VFC = () => {
  return (
    <Routes>
      <Route path='workflow/*' element={<WorkflowRoutes />} />
      <Route path='workflowmodel/*' element={<WorkflowmodelRoutes />} />
      <Route path='interaction/*' element={<InteractionRoutes />} />
      <Route path='task/*' element={<TaskRoutes />} />
      <Route path='masterdata/*' element={<MasterdataRoutes />} />

      <Route path='/' element={<PrivateRoutes />}>
        <Route index element={<RouteIndex />} />
      </Route>
    </Routes>
  )
}

export default ApplicationRouter

export const RouteIndex = () => {
  if (isEmbedded()) return null
  return (
    <div className='m-4'>
      <li>
        <Link to='/workflowmodel/list'>workflowmodel list</Link>
      </li>
      <li>
        <Link to='/task/list'>task list</Link>
      </li>
    </div>
  )
}
